import { Box, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import routes from "constants/routes";
import { useMemo } from "react";
import { USER_TYPE_LIST } from "constants/user-type";

/**
 * MenuPriceSetting Component
 *
 * Renders a list of price setting menu links for different price management pages.
 * The menu items are conditionally rendered based on the user's type.
 * @returns The rendered menu with links to price setting pages.
 */
export default function MenuPriceSetting() {
  const location = useLocation();
  const userType = localStorage.getItem("user_type");

  const leftMenuPriceSetting = useMemo(
    () => [
      {
        id: "mstProcFeeSetting",
        label: "工賃設定",
        route: routes.mstProcFeeSetting,
        permission: true,
      },
      {
        id: "itemPriceSetting",
        label: "タイヤ売価設定",
        route: routes.itemPriceSetting,
        permission: true,
      },
      {
        id: "mstWheelPriceSetting",
        label: "ホイール売価設定",
        route: routes.mstWheelPriceSetting,
        permission: true,
      },
      {
        id: "mst4BundlePriceTwSetSetting",
        label: "4本特価タイヤ設定",
        route: routes.mst4BundlePriceTwSetSetting,
        permission: userType === USER_TYPE_LIST.store.value || userType === "C0006",
      },
      {
        id: "mstWinterWheelPriceSetting",
        label: "廉価ホイールセット売価設定",
        route: routes.mstWinterWheelPriceSetting,
        permission: true,
      }
    ],
    [userType],
  );

  return (
    <Box>
      {leftMenuPriceSetting.map((item) =>
        item.permission ? (
          <Link key={item.id} to={item.route} style={{ textDecoration: "none" }}>
            <Typography
              sx={{
                textAlign: "left",
                fontSize: { xs: 20, md: 28 },
                color: item.route !== location.pathname ? "var(--gray-600)" : "var(--black)",
                fontWeight: item.route !== location.pathname ? "normal" : "bold",
              }}
            >
              {item.label}
            </Typography>
          </Link>
        ) : (
          ""
        ),
      )}
    </Box>
  );
}
